import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated as checkAuth } from '../utils/auth';

export default function ProtectedRoute() {
  // Use synchronous check instead of Zustand state to prevent race conditions
  const authenticated = checkAuth();

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
